<template>

	<div class="no-gutters text-center pb-3">
			<span property="itemListElement" typeof="ListItem">
				<a property="item" typeof="WebPage" title="Go to EveryLink." href="/" class="home">
					<span property="name">EveryLink</span>
				</a>
				<meta property="position" content="1">
			</span>
		<span property="itemListElement" typeof="ListItem">
				<span class="d"> &gt; </span>
				<a property="item" typeof="WebPage" title="Go to EveryLink." href="/people" class="home">
					<span property="name">People</span>
				</a>
				<meta property="position" content="1">
			</span>
		<span property="itemListElement" typeof="ListItem">
				<span class="d"> &gt; </span>
				<Skeletor class="d-inline-block" v-if="isLoading" width="140" height="15" />
				<span v-else property="name">{{ getFullName }}</span>
				<meta property="position" content="3">
			</span>
	</div>

	<div class="my-5">
		<div class="d-flex justify-content-center">
			<Skeletor class="my-3" v-if="isLoading" circle size="120" />
			<div v-else class="avatar my-3" :style="{ backgroundImage: `url(${getAvatar})` }"></div>
		</div>

		<div class="row no-gutters">
			<div class="col-12 text-center">
				<Skeletor class="mx-auto mb-2" v-if="isLoading" width="300" height="35" />
				<h2 v-else class="d-inline-block align-middle">
					{{ getFullName }}
				</h2>
			</div>
			<Skeletor class="mx-auto" v-if="isLoading" width="100" height="35" pill />
			<div v-else>
				<div v-if="!isFriend" class="text-center">
					<button @click="sendFriendRequest" class="btn btn-lg btn-primary">Invite</button>
				</div>
				<div v-else class="text-center">
					<a :href="`people/chat?id=${person.wpId}`" class="btn btn-lg btn-primary">Chat</a>
				</div>
			</div>
		</div>
	</div>

	<div v-if="isLoading" class="home">
		<div class="row">
			<div v-for="index in 3" :key="index" class="col-12 col-md-6 col-lg-4 mb-4">
				<Skeletor width="100%" height="430" />
			</div>
		</div>
	</div>
	<div v-else class="home">
		<div class="row" v-if="isFriend">
			<PostCard v-for="post in getPosts" :key="post._id" :post="post" :currentUserId="currentUser.wpId" />
		</div>
	</div>

</template>

<script lang="ts">
/* eslint-disable */
import { defineComponent } from 'vue'
import PostCard from '@/components/PostCard/PostCard.vue';
import axios from 'axios';

interface IUser {
	_id?: number
	wpId: number
	firstName: string
	lastName: string
	email: string
	friendRequests?: object[]
	friends?: object[]
	avatar?: string
	posts?: object[]
}

interface IFriend {
	blockFriend: boolean,
	_id: IUser
}

export default defineComponent({
	name: 'PersonView',
	components: {
		PostCard
	},
	data(){
		return {
			isLoading: false,
			wpUser: null as IUser | null,
			currentUser: null as IUser | null,
			person: null as IUser | null,
		};
	},
	computed: {
		getFullName(){
			return this.person?.firstName + ' ' + this.person?.lastName
		},
		getAvatar(){
			return this.person?.avatar || ''
		},
		getPosts(){
			return this.person?.posts || null
		},
		isFriend(){
			const friends = this.currentUser?.friends as IFriend[];
			return friends && this.person?._id ? friends.find((el) => el._id._id === this.person?._id) : false;
		}
	},
	async mounted(){
		this.isLoading = true
		await this.getUserFromWp()
		await this.getUser()
		await this.getPerson()
		this.isLoading = false
	},
	methods: {
		async getUserFromWp(){
			try {
				const res = await axios.get('/api/get_current_user.php')
				this.wpUser = res.data
			} catch (err){
				console.log(err)
			}
		},
		async getUser(){
			try {
				const res = await axios.get(`${process.env.VUE_APP_BASE_API_URI}/users/${this.wpUser?.wpId}`)
				this.currentUser = res.data
			} catch (err){
				console.log(err)
			}
		},

		async getPerson(){
			try {
				const res = await axios.get(`${process.env.VUE_APP_BASE_API_URI}/users/${this.$route.query.id}`)
				this.person = res.data
			} catch (err){
				console.log(err)
			}
		},

		async sendFriendRequest(){
			try {
				await axios.post(`${process.env.VUE_APP_BASE_API_URI}/friend/send-request`, {
					senderId: this.currentUser?._id,
					recipientId: this.person?._id
				})
				this.$notify(`An invite sent to ${this.getFullName}!`);
			} catch (err){
				console.log(err)
			}
		},
	},
})
</script>

<style scoped>

</style>
